import React from 'react';
import { t } from '@lingui/macro';
import { i18n } from '@lib/i18n';
import { RecordFlowIcon } from '@oca/icons';

const ExpensesMainPage = React.lazy(() =>
  import('./pages/main').then(module => ({
    default: module.ExpensesMainPage,
  })),
);

export const routes = [
  {
    path: '/expenses',
    component: ExpensesMainPage,
    navigation: {
      icon: <RecordFlowIcon />,
      name: i18n._(t`Expenses`),
      onlyTopLevelLink: true,
    },
    exact: true,
  },
];
